import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./Button.js";
import { FormDialog } from "./FormDialog.js";
/**
 * On the {@link FormDialog} shell (issue 214), which owns the native `<dialog>`, the scrim,
 * focus in and back, Escape and the Tab cycle. This adds the confirm's own rules: focus lands
 * on the primary, and Escape and a scrim click are the way out. Width 440.
 */
export function Dialog(props) {
    const { title, children, onClose } = props;
    const [first, second] = props.variant === "confirm"
        ? [
            { spec: props.cancel, variant: "secondary", action: "cancel" },
            { spec: props.confirm, variant: "primary", action: "confirm" },
        ]
        : [
            { spec: props.destructive, variant: "destructive", action: "destructive" },
            { spec: props.safe, variant: "primary", action: "safe" },
        ];
    const button = ({ spec, variant, action }) => {
        const { children: label, ...rest } = spec;
        return (_jsx(Button, { variant: variant, "data-dialog-action": action, ...rest, children: label }));
    };
    return (_jsx(FormDialog, { title: title, width: 440, initialFocus: `[data-dialog-action="${second.action}"]`, onEscape: onClose, onScrim: onClose, actions: _jsxs(_Fragment, { children: [button(first), button(second)] }), children: _jsx("div", { style: {
                fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
                color: "var(--ink-2)",
            }, children: children }) }));
}
